import { authenticationChannel } from '@codametrix/ui-common';
import { persistSessionState } from '../store/persist-session-state';

/**
 * Persist session state and reload after org switch. Called from jumpContext once
 * API work and in-app navigation are complete — not from beforeunload.
 */
export function finalizeContextSwitchReload(
  getState: () => CMx.ApplicationState,
  reload: () => void = () => window.location.reload()
): void {
  persistSessionState(getState());
  authenticationChannel.close();
  sessionStorage.removeItem('channel');
  reload();
}
